module.exports = __webpack_public_path__ + "static/package-3-bg-35f6115d0c7883254bebbafe64b4dae1.png";